// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3UPCB","buttons":"Footer_buttons__3S7ea"};